import { FlaskConical, Clock, Heart, Settings } from 'lucide-react';
import type { ReactNode } from 'react';
import type { Tab } from '@/shared/types';

interface LayoutProps {
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
  children: ReactNode;
}

const tabs: { id: Tab; label: string; icon: typeof FlaskConical }[] = [
  { id: 'generate', label: 'Микс', icon: FlaskConical },
  { id: 'history', label: 'История', icon: Clock },
  { id: 'favorites', label: 'Избранное', icon: Heart },
  { id: 'settings', label: 'Настройки', icon: Settings },
];

export function Layout({ activeTab, onTabChange, children }: LayoutProps): JSX.Element {
  return (
    <div className="min-h-screen bg-gradient-radial">
      <header className="sticky top-0 z-10 glass border-b border-white/5">
        <div className="mx-auto flex max-w-md items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-purple-500 to-pink-500">
              <FlaskConical className="h-5 w-5 text-white" />
            </div>
            <h1 className="text-xl font-bold text-gradient">Mixly</h1>
          </div>
          <span className="text-xs text-slate-600 dark:text-slate-400">AI миксолог</span>
        </div>
      </header>

      <main className="mx-auto max-w-md px-4 pb-24 pt-4">{children}</main>

      <nav className="fixed bottom-0 left-0 right-0 z-10 glass border-t border-black/5 dark:border-white/5 pb-safe">
        <div className="mx-auto flex max-w-md justify-around px-2 py-2">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = tab.id === activeTab;

            return (
              <button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                className={`flex flex-col items-center gap-1 rounded-xl px-4 py-2 transition-colors ${
                  isActive
                    ? 'text-pink-600 dark:text-pink-400'
                    : 'text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-slate-200'
                }`}
              >
                <Icon className={`h-5 w-5 ${isActive ? 'fill-current/20' : ''}`} />
                <span className="text-[10px] font-medium">{tab.label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
